export default __webpack_public_path__ + "0cd5c9bde1ca4016a823ea6ff22b0c55.svg";